/* app/js/src/components/live-sources/live-source-card/live-source-card.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.source-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 0;
  transition: box-shadow 0.2s ease;
}
.source-card:hover {
  box-shadow: 0px 1px 15px 0px rgba(0, 0, 0, 0.08);
}
.source-card__thumbnail {
  position: relative;
  width: 80px;
  height: 48px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 4px;
  background: rgb(235, 240, 244);
}
.source-card__thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.source-card__status-badge {
  position: absolute;
  top: 4px;
  left: 4px;
  padding: 1px 6px;
  border-radius: 4px;
  font-family: "Open Sans", sans-serif;
  font-size: 9px;
  font-weight: 600;
  line-height: 14px;
  color: #fff;
}
.source-card__status-badge.status--active {
  background-color: #61b965;
}
.source-card__status-badge.status--paused {
  background-color: rgb(255, 180, 0);
}
.source-card__status-badge.status--error {
  background-color: #ef5350;
}
.source-card__status-badge.status--idle {
  background-color: rgba(0, 0, 0, 0.54);
}
.source-card__status-badge.status--unknown {
  background-color: rgba(0, 0, 0, 0.54);
}
.source-card__info {
  flex: 1;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 16px;
  align-items: center;
  min-width: 0;
}
.source-card__name-col {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.source-card__name {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.85);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.source-card__detail-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.source-card__detail-label {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.54);
}
.source-card__detail-value {
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.85);
}
.source-card__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.source-card__action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  color: rgba(0, 0, 0, 0.6);
}
.source-card__action-btn:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.source-card__action-btn:focus {
  outline: none;
  box-shadow: none;
}
/*# sourceMappingURL=live-source-card.component.css.map */
